import {Button, Typography} from "@mui/material";

const ButtonCancel = ({onClick, text, width = 176, minWidth, height = 56, disabled = false, sx: sxProp}) => {
    return <Button
        onClick={onClick}
        variant="outlined"
        disabled={disabled}
        sx={[
            {
                width: width,
                minWidth: minWidth ?? width,
                height: height,
                borderRadius: "100px",
                color: (theme) => theme.palette.text.main,
                border: (theme) => `${theme.palette.secondary.add} 1px solid`,
                padding: "0 24px",
                textTransform: 'none',
                "&:hover": {
                    border: (theme) => `${theme.palette.secondary.add} 1px solid`,
                    backgroundColor: "inherit",
                },
                "&.Mui-disabled": {
                    borderColor: (theme) => theme.palette.action.disabled,
                },
            },
            ...(Array.isArray(sxProp) ? sxProp : sxProp ? [sxProp] : []),
        ]}
    >
        <Typography sx={{
            color: (theme) => disabled
                ? theme.palette.action.disabled
                : theme.palette.secondary.add,
            whiteSpace: 'nowrap',
            fontSize: "inherit",
        }}>{text}</Typography>
    </Button>
}
export default ButtonCancel